export const NON_PROMO_STICKY_FOOTER_REDESIGN_EXP_KEY = 'pen-4734_v1'
